import { forwardRef, useState, type ComponentPropsWithoutRef } from 'react';
import { tr } from '@/lib/i18n-core';
import { PHONE_MAX_DIGITS, PHONE_MIN_DIGITS, phoneDigitCount, sanitizePhoneTyping } from '@/lib/phone-entry';
import { Input } from './input';

type PhoneTextProps = Omit<ComponentPropsWithoutRef<typeof Input>, 'type'>;

export const PhoneText = forwardRef<HTMLInputElement, PhoneTextProps>(function PhoneText(
  { onChange, onBlur, value, ...props },
  ref,
) {
  const [touched, setTouched] = useState(false);
  const text = typeof value === 'string' ? value : '';
  const count = phoneDigitCount(text);
  const tooShort = touched && text.length > 0 && count < PHONE_MIN_DIGITS;
  return (
    <div>
      <Input
        ref={ref}
        type="tel"
        inputMode="tel"
        autoComplete="tel"
        dir="ltr"
        {...props}
        value={value}
        aria-invalid={tooShort || props['aria-invalid'] || undefined}
        onChange={(event) => {
          const cleaned = sanitizePhoneTyping(event.target.value);
          if (cleaned !== event.target.value) event.target.value = cleaned;
          onChange?.(event);
        }}
        onBlur={(event) => {
          setTouched(true);
          onBlur?.(event);
        }}
      />
      {tooShort && (
        <p role="alert" className="mt-1 text-xs text-destructive">
          {tr('admin', 'phone_number_length', { min: PHONE_MIN_DIGITS, max: PHONE_MAX_DIGITS })}
        </p>
      )}
    </div>
  );
});
